if (!customElements.get('bundle-offers')) {
  customElements.define(
    'bundle-offers',
    class BundleOffers extends HTMLElement {
      constructor() {
        super();

        this.radios = Array.from(this.querySelectorAll('.bundle-offers__radio'));
        this.rows = Array.from(this.querySelectorAll('.bundle-offers__row'));

        const form = document.getElementById(`product-form-${this.dataset.sectionId}`);
        this.hiddenIdInput = form ? form.querySelector('input[name="id"]') : null;

        this.radios.forEach((radio) => {
          radio.addEventListener('change', this.onTierChange.bind(this));
        });

        if (this.dataset.mainVariantLocked !== 'true' && typeof subscribe === 'function') {
          subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.dataset.sectionId) return;
            if (!event.data.variant) return;
            this.dataset.mainVariantId = event.data.variant.id;
            this.updateBundleVariantsForColor(event.data.variant.option1);
            this.syncHiddenInput();
          });
        }

        // Make the page's own "Add to cart" / dynamic checkout buttons submit
        // whichever bundle offer is currently selected, instead of adding a
        // second, separate button just for the bundle.
        this.syncHiddenInput();
      }

      // Each radio's data-bundle-variant-map is a JSON map of
      // {colorOptionValue: {id, price, was}}. When the shopper picks a different
      // color/option on the main product, swap which bundle variant each offer
      // refers to, and update the displayed price to match.
      updateBundleVariantsForColor(colorValue) {
        if (!colorValue) return;
        this.radios.forEach((radio) => {
          const mapJson = radio.dataset.bundleVariantMap;
          if (!mapJson) return;
          try {
            const map = JSON.parse(mapJson);
            const entry = map[colorValue];
            if (!entry) return;
            radio.dataset.bundleVariantId = entry.id;

            const row = radio.closest('.bundle-offers__row');
            const nowEl = row?.querySelector('[data-price-now]');
            const wasEl = row?.querySelector('[data-price-was]');
            if (nowEl && entry.price) nowEl.textContent = entry.price;
            if (wasEl && entry.was) wasEl.textContent = entry.was;
          } catch (e) {
            // ignore malformed map, keep previous variant id
          }
        });
      }

      onTierChange(event) {
        this.rows.forEach((row) => row.classList.remove('bundle-offers__row--selected'));
        const selectedRow = event.target.closest('.bundle-offers__row');
        if (selectedRow) selectedRow.classList.add('bundle-offers__row--selected');
        this.syncHiddenInput();
      }

      get selectedRadio() {
        return this.radios.find((radio) => radio.checked);
      }

      syncHiddenInput() {
        if (!this.hiddenIdInput) return;
        const radio = this.selectedRadio;
        const bundleVariantId = radio?.dataset.bundleVariantId;
        if (!bundleVariantId) return;
        this.hiddenIdInput.value = bundleVariantId;
        this.hiddenIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
